import { useState } from "react";
import { IconButton, Popover, Typography, Box, Divider } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const IconInfo = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ padding: "0" }}>
        <InfoIcon sx={{ height: "15px", width: "15px" }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minWidth: "240px",
          }}
        >
          <Typography fontSize="0.8rem" fontWeight="bold" mb={1}>
            Information
          </Typography>
          <Box mb={1}>
            <Typography
              fontSize="0.775rem"
              display="flex"
              justifyContent="space-between"
              gap={1}
            >
              <CheckCircleIcon
                sx={{
                  color: "green",
                  height: "18px",
                  width: "18px",
                }}
              />
              <span>Edited – (Corrected)</span>
            </Typography>
            <Divider sx={{ my: 1 }} />
          </Box>
          <Box >
            <Typography
              fontSize="0.775rem"
              display="flex"
              justifyContent="space-between"
              gap={1}
            >
              <ThumbUpAltIcon
                sx={{
                  color: "green",
                  height: "18px",
                  width: "18px",
                }}
              />
              <span>Unchanged - (Already Correct)</span>
            </Typography>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default IconInfo;
